import React from 'react'
import logo from 'assets/icons/logo.png'
import facebook from 'assets/icons/facebook.svg'
import instagram from 'assets/icons/instagram.svg'

function Footer() {
  // Rolagem suave com compensação do header fixo (~80px). Ajuste se necessário.
  const scrollToSection = (id) => {
    if (id === '#pagina-inicial') {
      window.scrollTo({ top: 0, behavior: 'smooth' })
      return
    }
    const el = document.querySelector(id)
    if (el) {
      const headerOffset = 80
      const y = el.getBoundingClientRect().top + window.scrollY - headerOffset
      window.scrollTo({ top: y, behavior: 'smooth' })
    }
  }

  return (
    <footer className='flex min-h-svh w-full bg-blue text-black' id='contatos'>
      <div className='flex flex-col items-center justify-between'>
        <FAQSection />
        <ManualLinksSection onNavigate={scrollToSection} />
        <CopyrightSection />
      </div>
    </footer>
  )
}

const FAQSection = () => (
  <section className='mt-8 flex w-11/12 flex-col items-center justify-center gap-4 rounded-lg bg-white p-4 text-center text-4xl md:w-9/12 md:p-10'>
    <header className='text-2xl font-bold md:text-5xl'>Ficou com alguma dúvida?</header>
    <p className='w-full text-lg md:w-11/12 md:text-xl'>
      Converse com um dos nossos especialistas e tenha um atendimento especializado e humanizado.
    </p>
    <button className='flex'>
      <a
        href='https://api.whatsapp.com/send?phone=5543988288426&text=Ol%C3%A1%2C%20Vim%20pelo%20site%20e%20gostaria%20de%20saber%20mais%20sobre%20seus%20servi%C3%A7os.'
        target='_blank'
        className='rounded-lg bg-yellow px-6 py-3 text-base font-semibold uppercase text-black transition-opacity duration-500 hover:opacity-75 md:text-lg'
        rel='noopener noreferrer'
      >
        Fale com a nossa equipe
      </a>
    </button>
  </section>
)

const ManualLinksSection = ({ onNavigate }) => (
  <section className='my-8 grid grid-cols-1 items-center justify-center gap-8 text-white md:w-9/12 md:grid-cols-2'>
    <div className='m-4 flex flex-col gap-8 md:flex-row'>
      <div className='flex flex-col gap-8'>
        {/* Institucional */}
        <div className='flex flex-col gap-4'>
          <header className='text-2xl font-semibold'>Institucional</header>
          <ul className='flex flex-col gap-2'>
            <li>
              <button
                type='button'
                onClick={() => onNavigate('#pagina-inicial')}
                className='text-left transition-colors duration-500 hover:text-yellow'
              >
                Página Inicial
              </button>
            </li>
            <li>
              <button
                type='button'
                onClick={() => onNavigate('#nossos-servicos')}
                className='text-left transition-colors duration-500 hover:text-yellow'
              >
                Nossos Serviços
              </button>
            </li>
            <li>
              <button
                type='button'
                onClick={() => onNavigate('#quem-somos')}
                className='text-left transition-colors duration-500 hover:text-yellow'
              >
                Quem Somos
              </button>
            </li>
          </ul>
        </div>

        {/* Redes Sociais */}
        <div className='hidden flex-col gap-2 md:flex md:items-center'>
          <a href='https://lidercredsolucoes.com.br' target='_blank' rel='noopener noreferrer'>
            <img src={logo} loading='lazy' alt='Líder Cred - Soluções Financeiras' className='w-44' />
          </a>

          <ul className='flex items-center gap-2 px-4'>
            <li>
              <a href='https://www.facebook.com/lidercredivp' target='_blank' rel='noopener noreferrer'>
                <img
                  src={facebook}
                  alt='Facebook'
                  className='h-16 w-16 transition-opacity duration-500 hover:opacity-75'
                />
              </a>
            </li>
            <li>
              <a href='https://www.instagram.com/lidercredivp' target='_blank' rel='noopener noreferrer'>
                <img
                  src={instagram}
                  alt='Instagram'
                  className='h-16 w-16 transition-opacity duration-500 hover:opacity-75'
                />
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Contato */}
      <div className='flex flex-col gap-4'>
        <header className='text-2xl font-semibold'>Contato</header>
        <ul className='flex flex-col gap-2'>
          <li>
            <a
              href='tel:4334840050'
              className='transition-colors duration-500 hover:text-yellow'
              target='_blank'
              rel='noopener noreferrer'
            >
              (43) 3484-0050
            </a>
          </li>
          <li>
            <a
              href='https://api.whatsapp.com/send?phone=5543988288426&text=Ol%C3%A1%2C%20Vim%20pelo%20site%20e%20gostaria%20de%20saber%20mais%20sobre%20seus%20servi%C3%A7os.'
              className='transition-colors duration-500 hover:text-yellow'
              target='_blank'
              rel='noopener noreferrer'
            >
              (43) 98828-8426
            </a>
          </li>
          <li>
            <a
              href='mailto:contato@lidercredsolucoes.com.br'
              className='transition-colors duration-500 hover:text-yellow'
              target='_blank'
              rel='noopener noreferrer'
            >
              contato@lidercredsolucoes.com.br
            </a>
          </li>
          <li>
            <a
              href='https://maps.app.goo.gl/4L8CgKV7d9f9vwuY6'
              className='transition-colors duration-500 hover:text-yellow'
              target='_blank'
              rel='noopener noreferrer'
            >
              Av. Castelo Branco, 920, Sala 07, Centro Comercial Cristal, Ivaiporã - PR, CEP 86870-000.
            </a>
          </li>
        </ul>
      </div>

      {/* Redes Sociais (Mobile) */}
      <div className='flex flex-col gap-2 md:hidden md:items-center'>
        <a href='https://lidercredsolucoes.com.br' target='_blank' rel='noopener noreferrer'>
          <img src={logo} loading='lazy' alt='Líder Cred - Soluções Financeiras' className='w-44' />
        </a>

        <ul className='flex items-center gap-2 px-4'>
          <li>
            <a href='https://www.facebook.com/lidercredivp' target='_blank' rel='noopener noreferrer'>
              <img
                src={facebook}
                alt='Facebook'
                className='h-16 w-16 transition-opacity duration-500 hover:opacity-75'
              />
            </a>
          </li>
          <li>
            <a href='https://www.instagram.com/lidercredivp' target='_blank' rel='noopener noreferrer'>
              <img
                src={instagram}
                alt='Instagram'
                className='h-16 w-16 transition-opacity duration-500 hover:opacity-75'
              />
            </a>
          </li>
        </ul>
      </div>
    </div>

    {/* Google Maps */}
    <div className='flex flex-col gap-4 md:items-center'>
      <iframe
        className='min-h-72 w-full'
        src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3638.0027924344317!2d-51.672886999999996!3d-24.241681099999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94eb5bfee14bc7e7%3A0x3ba7c1c5a3f61337!2sLidercred%20Emprestimos%20e%20Financiamentos!5e0!3m2!1sen!2sbr!4v1738843004479!5m2!1sen!2sbr'
        allowFullScreen
        loading='lazy'
        referrerPolicy='no-referrer-when-downgrade'
        title='Localização Líder Cred'
      />
    </div>
  </section>
)

function CopyrightSection() {
  return (
    <div className='flex w-full items-center justify-center bg-white p-4'>
      <div className='flex flex-col gap-4 text-justify text-sm md:w-10/12'>
        <a href='https://dorac.com.br' target='_blank' rel='noopener noreferrer'>
          &copy;2025 Líder Cred. Desenvolvido por Agência Dorac
        </a>

        <p className='text-xs'>
          A Líder Cred não é uma instituição financeira e não realiza operações de crédito diretamente. A Líder Cred é
          uma plataforma digital que atua como correspondente bancário para facilitar o processo de contratação de
          empréstimos. Como correspondente bancário, seguimos as diretrizes do Banco Central do Brasil, nos termos da
          Resolução nº 3.954, de 24 de fevereiro de 2011. Toda avaliação de crédito será realizada conforme a política
          de crédito da Instituição Financeira escolhida pelo usuário. Antes da contratação de qualquer serviço através
          de nossos parceiros, você receberá todas as condições e informações relativas ao produto a ser contratado, de
          forma completa e transparente. As taxas de juros, margem consignável e prazo de pagamento praticados nos
          empréstimos com consignação em pagamento dos Governos Federais, Estaduais e Municipais, Forças Armadas e INSS
          observam as determinações de cada convênio, bem como a política de crédito da instituição financeira a ser
          utilizada. NASCIMENTO & PIANOWSKI LTDA — CNPJ 35.683.210/0001-06 Endereço: Av. Castelo Branco, 920, Sala 07,
          Centro Comercial Cristal, Ivaiporã - PR, CEP 86870-000.
        </p>
      </div>
    </div>
  )
}

export default Footer
